module.exports = __webpack_public_path__ + "img/75980.7e9494da.svg";